/// <reference path="../../../../../rcwebmodels/reeferstatus.cs.d.ts" />
import * as React from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { PopupWindow } from '../sharedcomponents/PopupWindow';
import * as RCNGWindow from '../sharedcomponents/ConfirmationWindow';
import $ from 'jquery';
import lodashfilter from 'lodash/filter';
import { RCUtils } from './../../RCUtils';
import CheckboxTree from 'react-checkbox-tree';
import 'react-checkbox-tree/lib/react-checkbox-tree.css';
import uniq from 'lodash/uniq';
import * as Autosuggest from 'react-autosuggest';
import { List } from 'antd';
import { NewBookingCreate } from '../routecomponents/NewBookingCreate'
import { NewBookingEdit } from '../routecomponents/NewBookingEdit'
var Config: any = require('../../Config.json');
var self;
var selReefers;
var lastCheckedNodes = [];
var lastCheckedParentNode = "";
var selectedReefers = "";
var BookingReeferDesc = '';
var tempSelectedReefers = [];
export interface BookingReefers {
    ReeferIds: string;
    btnState: boolean;
    SelectedReefer: string;
    BookingDetails: server.BookingDetails
    BookingReefers: server.BookingSearchDetails;
    CommonBookingData: server.CommonBookingData;
    rowData: server.bookingReefer[];
    ReeeferDesc: any;
    CopyBookingNumber: any;
    ReeferwithUnitID: any[];
    ReeferforCreate: any;
    BookingNumber: any[]; // RCNG - 414 Fix Added BookingNuber
}
const emptyBookingDetails = {
    Shipper: '', Consignee: '', ShipperCode: '', POR: '', POL: '', POD: '', VesselETD: null, VesselETA: null, BLNumber: '', ContractParty: '', Consolidation: '',
    Agent: '', VesselCode: '', VoyageNumber: '', Call: '', Forwarder: '', Notify: '', BookingNumber: '', DEL: '', IsVVCModified: false,
    SelectedVesselCD: '',
    SelectedCall: '',
    SelectedVoyage: '',
    ArrSelectedVesselCD: '',
    ArrSelectedCall: '',
    ArrSelectedVoyage: '', userInput: 0, CustomerAccessGroupIDLoaded:'', BKCustomer:''
};
var emptyBookingReefers: server.BookingSearchDetails = {
    BookingReefers: '', SelectedBookingReefers: '', ReeferwithUnitID: [],BookingNumber:[]
}
var emptyCommonBookingData: server.CommonBookingData = {
    ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
    HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
    CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
    O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
};
export class SpecificBookingReefers extends React.Component<any, BookingReefers> {
    myRequest: any;
    constructor(props: any) {
        super(props);
        var initBookingReefers: server.BookingSearchDetails = {
            BookingReefers: this.props.formState.BookingReefers.BookingReefers, SelectedBookingReefers: this.props.formState.BookingReefers.SelectedBookingReefers,
            ReeferwithUnitID: this.props.formState.BookingReefers.ReeferwithUnitID,
            BookingNumber: this.props.formState.BookingReefers.BookingNumber
        }
        var emptyCommonBookingData: server.CommonBookingData = {
            ReeferIds: [], BookingNumber: '', BookedTemperature: '', BookedTemperatureUnit: '', BookedTemperatureMin: '', BookedTemperatureMax: '', HumiditySetPoint: '', VentSettings: '', GensetId: '', CommodityName: '', STCC: '', HSCode: '', ServiceLevel: '',
            HighValueCargo: 'none', CargoCareProfile: '', ThirdPartyAccess: '', CACTNotRequired: false, CTRequire: false, CARequire: false, CACTDifferByReefer: false,
            CTDays: '', CTMaxTemperature: '', PostCTTemperature: '', PostCTTemperatureRange: '', PostCTVentSettings: '', O2SetPoint: '', O2Min: '',
            O2Max: '', CO2SetPoint: '', CO2Min: '', CO2Max: '', CAGName: ''
        };
        //if (this.props.formState.isEdit)
        //BookingReeferDesc = 'If the reefers associated with the booking have changed, update the reefer IDs, search, and confirm the results.';
        //else
        //BookingReeferDesc = 'Search for the reefers associated with the booking. Confirm the results.';
        this.state = {
            ReeferIds: this.props.formState.BookingReefers.SelectedBookingReefers, btnState: false, SelectedReefer: this.props.formState.BookingReefers.BookingReefers, BookingDetails: emptyBookingDetails, BookingNumber: this.props.formState.BookingReefers.BookingNumber,
            BookingReefers: initBookingReefers,
            CommonBookingData: this.props.formState.isEdit ? this.props.formState.CommonBookingData : emptyCommonBookingData,
            rowData: this.props.formState.rowData,
            ReeferwithUnitID: this.props.formState.BookingReefers.ReeferwithUnitID,
            ReeeferDesc: this.props.formState.isEdit ? 'If the reefers associated with the booking have changed, update the reefer IDs, search, and confirm the results.' : 'Search for the reefers associated with the booking. Confirm the results.',
            CopyBookingNumber: this.props.formState.CopyBookingNumber, ReeferforCreate: this.props.formState.ReeferforCreate
        };
        
        if (this.props.formState.BookingReefers.BookingReefers != undefined && this.props.formState.BookingReefers.BookingReefers != null && this.props.formState.BookingReefers.BookingReefers != '') {
            tempSelectedReefers = this.props.formState.BookingReefers.BookingReefers.split(',');
        }
        self = this;
    }
    ApplyFilter() {
        if (self.state.SelectedReefer == '') {
            PopupWindow.showErrorMessage("Alert", "Please enter at least one Reefer ID.");
        }
        else {
            $('#globalLoader').show();
            var request = RCUtils.FetchRequest(Config.ApiBaseUrl + '/api/reeferstatus/GetSelectedReefers?SelectedReefer=' + this.state.SelectedReefer)
            fetch(request)
                .then(RCUtils.handleError)
                .then(response => response.json() as Promise<any[]>)
                .then(data => {
                    $('#globalLoader').hide();
                    if (data != null && data != undefined && data.length > 0) {
                        tempSelectedReefers = this.state.SelectedReefer.split(',');
                        var updatedBookingReefers: server.BookingSearchDetails = {
                            BookingReefers: self.state.SelectedReefer, SelectedBookingReefers: data.map(x => x.ReeferID).toString(), ReeferwithUnitID: data.map(x => x.ReeferwithUnitID), BookingNumber: data.map(x => x.BookingNumber) 
                        }
                        //BookingReefersData.ReeferwithUnitID = this.state.BookingList.map(x => x.ReeferwithUnitID);
                        this.setState({ ReeferIds: data.map(x => x.ReeferID).toString(), ReeferwithUnitID: data.map(x => x.ReeferwithUnitID), BookingReefers: updatedBookingReefers, btnState: true, BookingNumber: data.map(x => x.BookingNumber) });// RCNG - 414 Fix Added BookingNuber
                        if (this.props.formState.IsOpen == 'Edit') {
                            NewBookingEdit.UpdateButtonStyle(false);
                        }
                        if (this.props.formState.IsOpen == 'New') {
                            if (self.state.ReeferforCreate != "") {
                                if (data.map(x => x.ReeferID).toString().includes(self.state.ReeferforCreate)) {
                                    NewBookingCreate.UpdateButtonStyle(false);
                                }
                                else {
                                    PopupWindow.showErrorMessage("Alert", "Selected reefer " + self.state.ReeferforCreate + " not present in the list.");
                                    NewBookingCreate.UpdateButtonStyle(true);
                                    return;
                                }


                            }
                            else {
                                NewBookingCreate.UpdateButtonStyle(false);
                            }
                        }

                    }
                    else {
                        PopupWindow.showErrorMessage("Alert", 'No results found.');
                    }
                });
        }
    }
    ReeferIdschange(event: React.FormEvent<HTMLTextAreaElement>) {
        var commaValue: string = this.GetMultiLineCsv(event.currentTarget.value);
        this.ValidateButtons(commaValue);
        //this.setState({
        //    SelectedReefer: commaValue
        //}, () => { this.ValidateButtons(commaValue) });

        this.setState({
            SelectedReefer: commaValue
        });
        //if (this.props.formState.IsOpen == 'Edit') {
        //    NewBookingEdit.UpdateButtonStyle(true);
        //}
        //if (this.props.formState.IsOpen == 'New') {
        //    NewBookingCreate.UpdateButtonStyle(true);
        //}
    }

    ValidateButtons(commaValue) {
        //if (this.state.SelectedReefer != undefined && this.state.SelectedReefer != null && this.state.SelectedReefer != '') {
        var unique = [];
        //tempSelectedReefers = this.state.SelectedReefer.split(',');
        if (tempSelectedReefers.length > 0) {
            var temp = tempSelectedReefers.filter(item => item);
            temp.forEach(element => {
                if (!unique.includes(element)) {
                    unique.push(element)
                }

            })
        }
        //}
        var enterReefer = commaValue.split(',');
        var uniqueCommon = [];
        var tempCommon = enterReefer.filter(item => item);
        tempCommon.forEach(element => {
            if (!uniqueCommon.includes(element)) {
                uniqueCommon.push(element)
            }

        })
        var difference_a1 = [];
        if (unique != undefined)
            difference_a1 = unique.filter(x => !uniqueCommon.includes(x));

        var difference_a2 = [];
        if (unique != undefined)
            difference_a2 = uniqueCommon.filter(x => !unique.includes(x));
        else
            difference_a2 = uniqueCommon;
       if (this.state.ReeferIds == '' || difference_a1.length > 0 || difference_a2.length > 0) {
            if (this.props.formState.IsOpen == 'Edit') {
                NewBookingEdit.UpdateButtonStyle(false);//RCNG-925
            }
            if (this.props.formState.IsOpen == 'New') {
                NewBookingCreate.UpdateButtonStyle(false);//RCNG-925
            }

        }
        else {
            if (this.props.formState.IsOpen == 'Edit') {
                NewBookingEdit.UpdateButtonStyle(false);
            }
            if (this.props.formState.IsOpen == 'New') {
                NewBookingCreate.UpdateButtonStyle(false);
            }
        }
    }

    GetMultiLineCsv(value) {
        //while (value.Contains(Environment.NewLine) || value.Contains('\r') || value.Contains('\n'))--->environment new line pending
        while (value.includes('\r') || value.includes('\n') || value.includes(';') || value.includes(' ')) {
            //value = value.Replace(Environment.NewLine, ",");
            value = value.replace('\r'.toString(), ",");
            value = value.replace('\n'.toString(), ",");
            value = value.replace(';'.toString(), ",");
            value = value.replace(' '.toString(), ",");
        }
        while (value.includes(",,")) {
            value = value.replace(",,", ",");
        }
        //s = s.Replace(",", "," + Environment.NewLine);
        return value;
    }
    ClearFilter() {
        tempSelectedReefers = [];
        if (this.props.formState.IsOpen == 'Edit') {
            NewBookingEdit.UpdateButtonStyle(true);
        }
        if (this.props.formState.IsOpen == 'New') {
            NewBookingCreate.UpdateButtonStyle(true);
        }
        this.setState({
            ReeferIds: '', btnState: false, SelectedReefer: '', ReeferwithUnitID: []
        });
    }
    static BackScreen() {
        if (self.props.formState.IsOpen == 'Edit') {
            NewBookingEdit.UpdateButtonStyle(false);
        }
        if (self.props.formState.IsOpen == 'New') {
            NewBookingCreate.UpdateButtonStyle(false);
        }
        self.props.renderWizardPage(1, self.state, 2);
    }
    //RCNG-414 Fix
     BookingConfirmationWindow()
    {
        if (self.state.BookingNumber != undefined && self.state.BookingNumber.length >0 && self.state.BookingNumber.filter((item) => item !== 0).length > 0) {
            $('#BookingonfirmModal').show();
        }
        else {
            self.props.renderWizardPage(3, self.state, 2);
        }
    }
    closeBookingModel() {
        $('#BookingonfirmModal').hide();
    }
    closeAssetConfirmation() {
        $("#confirmModal").css("display", "none");
    }
    closeBookingConfirmation() {
        $("#BookingonfirmModal").css("display", "none");
    }
    performAddAssetBookingNoAction() {
        this.closeBookingModel();

        // $('#addAssetModal .btn-close').click();
    }
    performAddAssetBookingYesAction() {
        this.closeBookingModel();
        self.props.renderWizardPage(3, self.state, 2);
    }
    //RCNG-414 Fix End
    static NextScreen() {
        if (self.props.formState.IsOpen == 'New') {
            if (self.state.ReeferforCreate != "") {
                if (self.state.ReeferIds.includes(self.state.ReeferforCreate)) {
                    if (self.state.ReeferIds != null && self.state.ReeferIds != '' && self.state.ReeferIds != undefined) {
                        // self.props.renderWizardPage(3, self.state, 2);
                        self.BookingConfirmationWindow();//RCNG-414 Fix
                    }
                    else {
                        //PopupWindow.showErrorMessage("Alert", "Please Select at least one Reefer.");
                        RCNGWindow.ConfirmWindow.showConfirmBox("No reefer(s) has been selected. Do you want to create booking without reefer(s)?",
                            self.YesContinueToCreate.bind(this), self.CloseConfirmation.bind(this));//RCNG-925
                    }
                }
                else {
                    PopupWindow.showErrorMessage("Alert", "Selected reefer " + self.state.ReeferforCreate + " not present in the list.");
                    NewBookingCreate.UpdateButtonStyle(true);
                    return;
                }


            }
            else {
                if (self.state.ReeferIds != null && self.state.ReeferIds != '' && self.state.ReeferIds != undefined)
                {
                    self.BookingConfirmationWindow();//RCNG-414 Fix
                }
                else {
                    //PopupWindow.showErrorMessage("Alert", "Please Select at least one Reefer.");
                    RCNGWindow.ConfirmWindow.showConfirmBox("No reefer(s) has been selected. Do you want to create booking without reefer(s)?",
                        self.YesContinueToCreate.bind(this), self.CloseConfirmation.bind(this));//RCNG-925
                }
            }
        }
        else {
            if (self.state.ReeferIds != null && self.state.ReeferIds != '' && self.state.ReeferIds != undefined) {
                self.BookingConfirmationWindow();
                //self.props.renderWizardPage(3, self.state, 2);
            }
            else {
                //PopupWindow.showErrorMessage("Alert", "Please Select at least one Reefer.");
                RCNGWindow.ConfirmWindow.showConfirmBox("No reefer(s) has been selected. Do you want to update booking without reefer(s)?",
                    self.YesContinueToUpdate.bind(this), self.CloseConfirmation.bind(this));//RCNG-925
            }
        }
    }

    YesContinueToCreate() {
        RCNGWindow.ConfirmWindow.close();
        self.props.prepareSubmitWithoutReefers();
        //self.props.renderWizardPage(3, self.state, 2);
    }

    YesContinueToUpdate() {
        RCNGWindow.ConfirmWindow.close();
        self.props.prepareUpdateWithoutReefers();
        //self.props.renderWizardPage(3, self.state, 2);
    }

    CloseConfirmation() {
        RCNGWindow.ConfirmWindow.close();
    }

    componentDidMount() {
        var BookingInfoDetails = emptyBookingDetails;
        BookingInfoDetails.Shipper = this.props.formState.BookingDetails.Shipper;
        BookingInfoDetails.Consignee = this.props.formState.BookingDetails.Consignee;
        BookingInfoDetails.ShipperCode = this.props.formState.BookingDetails.ShipperCode;
        BookingInfoDetails.POR = this.props.formState.BookingDetails.POR;
        BookingInfoDetails.POL = this.props.formState.BookingDetails.POL;
        BookingInfoDetails.POD = this.props.formState.BookingDetails.POD;
        BookingInfoDetails.VesselETD = this.props.formState.BookingDetails.VesselETD;
        BookingInfoDetails.VesselETA = this.props.formState.BookingDetails.VesselETA;
        BookingInfoDetails.BLNumber = this.props.formState.BookingDetails.BLNumber;
        BookingInfoDetails.ContractParty = this.props.formState.BookingDetails.ContractParty;
        BookingInfoDetails.Consolidation = this.props.formState.BookingDetails.Consolidation;
        BookingInfoDetails.Agent = this.props.formState.BookingDetails.Agent;
        BookingInfoDetails.VesselCode = this.props.formState.BookingDetails.VesselCode;
        BookingInfoDetails.VoyageNumber = this.props.formState.BookingDetails.VoyageNumber;
        BookingInfoDetails.Call = this.props.formState.BookingDetails.Call;
        BookingInfoDetails.Forwarder = this.props.formState.BookingDetails.Forwarder;
        BookingInfoDetails.Notify = this.props.formState.BookingDetails.Notify;
        BookingInfoDetails.BookingNumber = this.props.formState.BookingDetails.BookingNumber;
        BookingInfoDetails.DEL = this.props.formState.BookingDetails.DEL;
        BookingInfoDetails.SelectedVesselCD = this.props.formState.BookingDetails.SelectedVesselCD;
        BookingInfoDetails.SelectedCall = this.props.formState.BookingDetails.SelectedCall;
        BookingInfoDetails.SelectedVoyage = this.props.formState.BookingDetails.SelectedVoyage;
        BookingInfoDetails.ArrSelectedVesselCD = this.props.formState.BookingDetails.ArrSelectedVesselCD;
        BookingInfoDetails.ArrSelectedCall = this.props.formState.BookingDetails.ArrSelectedCall;
        BookingInfoDetails.ArrSelectedVoyage = this.props.formState.BookingDetails.ArrSelectedVoyage;
        BookingInfoDetails.userInput = this.props.formState.BookingDetails.userInput;
        BookingInfoDetails.BKCustomer = this.props.formState.BookingDetails.BKCustomer;
        this.setState({ BookingDetails: BookingInfoDetails });
    }
    
    public render() {

        return <div>



            <div className="row mt-4">
                <div className="col-md-12">
                    <div className='text-center'>
                        <span className='fw-semibold'>{this.state.ReeeferDesc}</span>
                    </div>

                </div>

            </div>


            <div className="col-md-12">
                <div className="row mt-2">
                    <div className="col-md-2 pe-0 text-md-end"><label className='col-form-label'>Reefer ID(s): </label></div>
                    <div className="col-md-8"><textarea className='form-control textarea-150' onChange={e => this.ReeferIdschange(e)} value={this.state.SelectedReefer}></textarea></div>
                </div>
                <div className="row mt-2">
                    <div className="col-md-2"></div>
                    <div className="col-md-8 text-end">
                        <button type='button' className='btn btn-primary me-2' onClick={this.ClearFilter.bind(this)}>Clear</button>
                        <button type='button' className='btn btn-primary' onClick={this.ApplyFilter.bind(this)}>Search</button>                        
                    </div>
                </div>
                <div className="row mt-3">
                    <div className="col-md-2 pe-0 text-md-end"><label className='col-form-label'><b>Result: </b></label></div>
                    <div className="col-md-8"><div className='Booking-Result'>{this.state.ReeferIds}</div></div>
                </div>
            </div>

            <div className="modal" role="dialog" id="BookingonfirmModal">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Confirmation</h5>
                            <button type="button" className="btn-close" aria-label="Close" onClick={this.closeBookingModel.bind(this)}><span aria-hidden="true">&times;</span></button>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="alert-text">
                                       One or more Reefers are already associated with Booking. Do you want to override the existing Booking association?
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" onClick={() => this.performAddAssetBookingNoAction()} >No</button>
                            <button type="button" className="btn btn-primary" onClick={() => this.performAddAssetBookingYesAction()}  >Yes</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    }
}